import { render } from "./EvidenceUploadZone.vue?vue&type=template&id=5d36ff90&scoped=true"
import script from "./EvidenceUploadZone.vue?vue&type=script&lang=js"
export * from "./EvidenceUploadZone.vue?vue&type=script&lang=js"

import "./EvidenceUploadZone.vue?vue&type=style&index=0&id=5d36ff90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36ff90"]])

export default __exports__